"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _cnbuilder = require("cnbuilder");
var _getYear = _interopRequireDefault(require("date-fns/getYear"));
var _dist = require("react-day-picker/dist");
var _reactI18next = require("react-i18next");
var _uuid = require("uuid");
var _useMonths = _interopRequireDefault(require("../Context/l10n/DateTime/useMonths"));
var _Select = _interopRequireDefault(require("../Select"));
var _DropdownNavigationModule = _interopRequireDefault(require("./DropdownNavigation.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function getYears(_ref) {
  let {
    fromDate,
    toDate
  } = _ref;
  const years = [];
  for (let i = (0, _getYear.default)(fromDate); i <= (0, _getYear.default)(toDate); i++) {
    const label = String(i);
    years.push({
      label,
      value: label
    });
  }
  return years;
}
const DropdownNavigation = _ref2 => {
  let {
    date,
    fromDate,
    toDate
  } = _ref2;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    classNameMonthSelect,
    classNameYearSelect,
    testAttrMonthSelect,
    testAttrYearSelect,
    i18nMonthLabel,
    i18nYearLabel,
    disableNavigation
  } = (0, _dist.useDayPicker)();
  const {
    goToMonth
  } = (0, _dist.useNavigation)();
  const {
    current: uuid
  } = (0, _react.useRef)((0, _uuid.v4)());
  const [month, setMonth] = (0, _react.useState)(String(date === null || date === void 0 ? void 0 : date.getMonth()));
  const [year, setYear] = (0, _react.useState)(String(date === null || date === void 0 ? void 0 : date.getFullYear()));
  const {
    allMonths
  } = (0, _useMonths.default)({
    width: 'LLLL',
    forSelect: true,
    startingMonthZero: true // month index begins at zero
  });
  const onMonthChange = _ref3 => {
    let {
      value
    } = _ref3;
    setMonth(value);
    goToMonth(new Date(year, value));
  };
  const onYearChange = _ref4 => {
    let {
      value
    } = _ref4;
    setYear(value);
    goToMonth(new Date(value, month));
  };
  const onKeydownMonth = e => {
    // if Shift-TAB key pressed should focusing on the Close button
    if (e.shiftKey && e.keyCode === 9) {
      const closeCalBtn = document.querySelector('button[data-trap="calendarCloseBtn"]');
      e.preventDefault();
      if (closeCalBtn) {
        closeCalBtn.focus();
      }
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.default, {
      id: "month-".concat(uuid),
      testAttrItem: testAttrMonthSelect,
      classNameRoot: (0, _cnbuilder.cnb)(_DropdownNavigationModule.default.select, classNameMonthSelect),
      i18nItemLabel: i18nMonthLabel || t('ui:calendar.month'),
      items: allMonths,
      value: month,
      disabled: disableNavigation,
      "data-trap": "prevMonthDropNav",
      onChange: onMonthChange,
      onKeyDown: onKeydownMonth
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.default, {
      id: "year-".concat(uuid),
      testAttrItem: testAttrYearSelect,
      classNameRoot: (0, _cnbuilder.cnb)(_DropdownNavigationModule.default.select, classNameYearSelect),
      i18nItemLabel: i18nYearLabel || t('ui:calendar.year'),
      items: getYears({
        fromDate,
        toDate
      }),
      value: year,
      disabled: disableNavigation,
      "data-trap": "nextMonthDropNav",
      onChange: onYearChange
    })]
  });
};
var _default = exports.default = DropdownNavigation;